import { AxiosResponse } from 'axios';
import { axiosSmartCoolersInstance } from '@/config/apiConfig';
import {
  IFetchAppLogs,
  IAppLogResponse,
} from '@/pages/SmartCoolers/smartCooler.interface';
import { directFileDownload } from '@/constant/downloadReport/downloadReport';
import _ from 'lodash';
import { ALL_OPERATOR } from '@/constant/global/global.constant';

export const fetchAppLogs = ({
  page,
  limit,
  operatorId,
  androidDeviceId,
  deviceId,
  marketId,
  status,
  orderBy,
  order,
  logId,
  startDate,
  endDate,
}: IFetchAppLogs): Promise<AxiosResponse<IAppLogResponse>> => {
  return axiosSmartCoolersInstance({
    url: '/app-logs',
    method: 'GET',
    params: {
      page,
      limit,
      ...(operatorId && operatorId !== ALL_OPERATOR.sourceId
        ? { operatorId }
        : {}),
      ...(androidDeviceId ? { androidDeviceId } : {}),
      ...(deviceId ? { deviceId } : {}),
      ...(marketId ? { marketId } : {}),
      ...(status && status !== 'ALL' ? { status } : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(order ? { order } : {}),
      ...(logId ? { logId } : {}),
      ...(!_.isEmpty(startDate) ? { startDate } : {}),
      ...(!_.isEmpty(endDate) ? { endDate } : {}),
    },
  });
};

export const downloadAppLogReport = (logId: string) => {
  return directFileDownload({
    url: `/app-logs/download?logId=${logId}`,
  });
};
